import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import PersonDetails from "@/shared/model/personDetails";
import PersonDetailsId from "@/shared/model/personDetailsId";
import Person from "@/shared/model/person";

interface Props {
  person?: Person,
  details?: PersonDetails
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'PersonEvbActivationComponent',
  props: {
    person: { default: undefined },
    details: { default: undefined }
  },
  setup(__props: any) {


const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", null, [
      _createElementVNode("tr", null, [
        _cache[0] || (_cache[0] = _createElementVNode("td", null, "Standard Anzahl Tage", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.details?.getNumberValue(_unref(PersonDetailsId).EvbActivationDefaultDuration)??(__props.person?.isBranch()?7:30)
          }, null, 8, ["value"])
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[1] || (_cache[1] = _createElementVNode("td", null, "Maximale Anzahl Tage", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.details?.getNumberValue(_unref(PersonDetailsId).EvbActivationMaxDuration)??(__props.person?.isBranch()?30:90)
          }, null, 8, ["value"])
        ])
      ])
    ])
  ]))
}
}

})